<template>
  <div class="gang-drill h100">
    <div class="h100 y-auto">
      <div class="head-title">
        <span id="span_bgix4mmnji">{{
          $t('cuttingDock.drillSettings.enable')
        }}</span>
        <a-switch
          v-model="formData.enabled"
          id="engraving_setting_drill_enable_switch"
        ></a-switch>
      </div>
      <div v-show="formData.enabled">
        <div class="gang-drill-table">
          <div class="table-box">
            <el-table
              :data="formData.drills"
              :row-class-name="tableRowClassName"
              :cell-class-name="tableCellClassName"
              @cell-click="cellClick"
              :max-height="500"
            >
              <el-table-column
                :label="$t('cuttingDock.drillSettings.toolTable.use')"
                prop="isUsed"
              >
                <template slot-scope="scope">
                  <a-checkbox
                    v-model="scope.row.isUsed"
                    :id="`engraving_setting_drill_knife_table_${scope.row.index}_isUsed_checkbox`"
                  ></a-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(knife, index) in knifeColumn"
                :key="index"
                :label="translateLang(knife.label)"
                :prop="knife.prop"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      scope.row.index === rowIndex &&
                      scope.column.index === columnIndex
                    "
                  >
                    <el-input
                      v-model="scope.row[knife.prop]"
                      ref="editInput"
                      :type="textareaJudge(knife.prop)"
                      resize="none"
                      size="mini"
                      autosize
                      @blur="inputBlur(scope.row, knife.prop)"
                      @change="inputBlur(scope.row, knife.prop)"
                      @input="cancelBenchDrill(scope.row, knife.prop)"
                      :id="`engraving_setting_drill_knife_table_${scope.row.index}_${knife.prop}_input`"
                    />
                  </div>
                  <div class="knives_type" style="white-space: pre-line" v-else>
                    <span
                      :id="`engraving_setting_drill_knife_table_${scope.row.index}_${knife.prop}`"
                      >{{ scope.row[knife.prop] }}</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="
                  $t('cuttingDock.drillSettings.toolTable.benchmarkDrill')
                "
                prop="benchDrill"
              >
                <template slot-scope="scope">
                  <a-checkbox
                    v-model="scope.row._selected"
                    :disabled="scope.row.number == ''"
                    @change="changeBenchDrill(scope.row)"
                    :id="`engraving_setting_drill_knife_table_${scope.row.index}_benchDrill_checkbox`"
                  ></a-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="operation-btn">
            <a-button
              @click="addNewKnife"
              class="mr12"
              id="engraving_setting_drill_add_btn"
              >{{
                $t('cuttingDock.drillSettings.toolTable.addKnife')
              }}</a-button
            >
            <a-button
              @click="deleteKnife"
              id="engraving_setting_drill_delete_btn"
              >{{
                $t('cuttingDock.drillSettings.toolTable.deleteKnife')
              }}</a-button
            >
          </div>
        </div>
        <div class="code-box">
          <div>
            <div>
              <span id="span_1t40kuizrc"
                >{{ $t('cuttingDock.drillSettings.prefix') }}:</span
              >
              <a-textarea
                :placeholder="$t('cuttingDock.drillSettings.prefix')"
                v-model="formData.prefix"
                id="engraving_setting_drill_prefix_textarea"
              ></a-textarea>
            </div>
            <div>
              <span id="span_pkau8l3z7n"
                >{{ $t('cuttingDock.drillSettings.suffix') }}:</span
              >
              <a-textarea
                :placeholder="$t('cuttingDock.drillSettings.suffix')"
                v-model="formData.suffix"
                id="engraving_setting_drill_suffix_textarea"
              ></a-textarea>
            </div>
          </div>
          <div>
            <div>
              <span id="span_3frsptgsdj"
                >{{ $t('cuttingDock.drillSettings.startCode') }}：</span
              >
              <a-textarea
                :placeholder="$t('cuttingDock.drillSettings.startCode')"
                v-model="formData.beginCode"
                id="engraving_setting_drill_beginCode_textarea"
              ></a-textarea>
            </div>
            <div>
              <span id="span_yn053lilf9"
                >{{ $t('cuttingDock.drillSettings.endCode') }}：</span
              >
              <a-textarea
                :placeholder="$t('cuttingDock.drillSettings.endCode')"
                v-model="formData.endCode"
                id="engraving_setting_drill_endCode_textarea"
              ></a-textarea>
            </div>
          </div>
        </div>
        <!-- 加工设置 -->
        <div class="process-setting">
          <div id="div_c7gq2k3j8v" class="fs20 mb20">
            {{ $t('cuttingDock.drillSettings.processSetting.title') }}
          </div>
          <div class="mb20">
            <span id="span_dt40pt0iqi"
              >{{ $t('cuttingDock.drillSettings.processSetting.mode') }}：</span
            >
            <a-radio-group v-model="formData.drill_process_mode">
              <a-radio
                v-for="item in drillMode"
                :key="item.label"
                :value="item.value"
                :id="item.id"
                >{{ item.label
                }}<span
                  v-if="item.value === 'group_hole'"
                  style="color: red"
                  class="ml10"
                ></span
              ></a-radio>
            </a-radio-group>
            <span id="span_rbaylgj8j2" style="color: #f00">{{
              $t('cuttingDock.drillSettings.processSetting.drill_benchmark_Tip')
            }}</span>
          </div>
          <!--          排钻组合下刀-->
          <div
            class="drilling-part"
            v-if="formData.drill_process_mode === 'recent_hole'"
          >
            <div class="drilling-title">
              <span id="span_fm6gztpxnj" style="margin-right: 10px">{{
                $t('cuttingDock.drillSettings.combineKnife')
              }}</span>
              <el-checkbox
                v-model="isDriliingChecked"
                id="engraving_setting_drill_isDriliingChecked_checkbox"
              ></el-checkbox>
            </div>
            <div
              class="drilling-content"
              v-show="isDriliingChecked || engravSwitchCloseAlwaysShow"
            >
              <div class="left-table">
                <el-table
                  :data="drillTableData"
                  :span-method="arraySpanMethod"
                  :row-style="comstumRow"
                  @cell-click="drillCellClick"
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    align="center"
                    prop="name"
                    label=""
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="prefix"
                    :label="$t('cuttingDock.drillSettings.combineTable.prefix')"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <div style="min-width: 159px; min-height: 23px">
                        <a-textarea
                          v-model="scope.row.prefix"
                          size="small"
                          :id="`engraving_setting_drill_table_${getIdKey(
                            scope.row
                          )}_prefix_input`"
                          :disabled="
                            formData.drill_process_mode === 'group_hole'
                          "
                          @input="
                            handleTableInput(scope.row, scope.column.property)
                          "
                          @drop="
                            handleDrop($event, scope.row, scope.column.property)
                          "
                        />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="suffix"
                    :label="$t('cuttingDock.drillSettings.combineTable.suffix')"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <div style="min-width: 159px; min-height: 23px">
                        <a-textarea
                          v-model="scope.row.suffix"
                          size="small"
                          :id="`engraving_setting_drill_table_${getIdKey(
                            scope.row
                          )}_suffix_input`"
                          :disabled="
                            formData.drill_process_mode === 'group_hole'
                          "
                          @input="
                            handleTableInput(scope.row, scope.column.property)
                          "
                          @drop="
                            handleDrop($event, scope.row, scope.column.property)
                          "
                        />
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="right-text">
                <p id="p_77ufj6ez38">
                  {{ $t('cuttingDock.drillSettings.combineTable.example') }}
                </p>
                <p
                  v-for="(text, index) in drillCode.split('\n')"
                  :key="index"
                  class="drill-fix"
                  :id="`engraving_setting_drill_example_${index}`"
                >
                  {{ text }}
                </p>
                <!-- 排钻组合池 -->
                <div style="width: 680px" class="tag-box mt20">
                  <div class="custom-form-head">
                    <span>{{
                      $t(
                        'cuttingDock.NCExportSettings.fileNameSettings.labelPool'
                      )
                    }}</span>
                    <span class="ml10">{{
                      $t(
                        'cuttingDock.NCExportSettings.fileNameSettings.dragTip'
                      )
                    }}</span>
                  </div>
                  <div style="box-sizing: border-box; padding: 0 24px">
                    <div class="tag-item">
                      <span class="flex-box--0 pt10"
                        >{{
                          $t(
                            'cuttingDock.drillSettings.tagPool.drillRowNumber'
                          )
                        }}：</span
                      >
                      <div class="tags">
                        <span
                          v-for="(item, index) in drillInfo.drillingNum"
                          :key="index + '1'"
                          :class="`tag-item${index}`"
                          @dragstart="handleStartDrag($event, item)"
                          @click="handleCopyTag(index, item)"
                          data-clipboard-action="copy"
                          :data-clipboard-text="
                            '{' + item.label_name_show + '}'
                          "
                          draggable="true"
                          :id="`engraving_setting_exportSetting_tagList_${index}`"
                          >{{ item.label_name_show }}</span
                        >
                      </div>
                    </div>
                    <div class="tag-item">
                      <span class="flex-box--0 pt10"
                        >{{
                          $t('cuttingDock.drillSettings.combineTable.prefix')
                        }}：</span
                      >
                      <div class="tags">
                        <span
                          v-for="(item, index) in drillInfo.drillingNumPrefix"
                          :key="index + '1'"
                          :class="`tag-item${index}`"
                          @dragstart="handleStartDrag($event, item)"
                          @click="handleCopyTag(index, item)"
                          data-clipboard-action="copy"
                          :data-clipboard-text="
                            '{' + item.label_name_show + '}'
                          "
                          draggable="true"
                          :id="`engraving_setting_exportSetting_tagList_${index}`"
                          >{{ item.label_name_show }}</span
                        >
                      </div>
                    </div>
                    <div class="tag-item">
                      <span class="flex-box--0 pt10"
                        >{{
                          $t('cuttingDock.drillSettings.combineTable.suffix')
                        }}：</span
                      >
                      <div class="tags">
                        <span
                          v-for="(item, index) in drillInfo.drillingNumSuffix"
                          :key="index + '1'"
                          :class="`tag-item${index}`"
                          @dragstart="handleStartDrag($event, item)"
                          @click="handleCopyTag(index, item)"
                          data-clipboard-action="copy"
                          :data-clipboard-text="
                            '{' + item.label_name_show + '}'
                          "
                          draggable="true"
                          :id="`engraving_setting_exportSetting_tagList_${index}`"
                          >{{ item.label_name_show }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="drilling-bottom"
              v-show="isDriliingChecked || engravSwitchCloseAlwaysShow"
            >
              <el-button
                @click="handleAddHole"
                id="engraving_setting_drill_addHole_btn"
                :disabled="formData.drill_process_mode === 'group_hole'"
                >{{
                  $t('cuttingDock.drillSettings.combineTable.addExtraHole')
                }}</el-button
              >
              <el-button
                @click="handleDeleteHole"
                id="engraving_setting_drill_deleteHole_btn"
                :disabled="formData.drill_process_mode === 'group_hole'"
                >{{
                  $t('cuttingDock.drillSettings.combineTable.deleteExtraHole')
                }}</el-button
              >
            </div>
          </div>

          <!--          排钻组合下刀基准-->
          <div
            class="mt20"
            v-if="
              formData.drill_process_mode === 'recent_hole' &&
              (isDriliingChecked || engravSwitchCloseAlwaysShow)
            "
          >
            <span id="span_68xs1kbrba"
              >{{
                $t('cuttingDock.drillSettings.processSetting.drill_benchmark')
              }}：</span
            >
            <a-radio-group v-model="formData.drill_benchmark">
              <a-radio id="a_radio_3a1ijk578y" value="main">{{
                $t('cuttingDock.drillSettings.processSetting.mainHole')
              }}</a-radio>
              <a-radio id="a_radio_ut7mbiiit6" value="end">{{
                $t('cuttingDock.drillSettings.processSetting.secondaryHole')
              }}</a-radio>
            </a-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getElectronicSawLabel } from '@/apis/tag'
import { translate } from '@/util/commonFun'
import { buryPointApi, genUniId, verifyInputNumber } from '@/util/commonFuncs'
import { webId } from '@/util/configure'
import { mapGetters, mapState } from 'vuex'

import { gangDrillTableConfigList as gangDrillTableConfig } from './config/tableConfig'

const textAreaFieldSet = new Set([
  'feedRate',
  'number',
  'number2',
  'moveZF',
  'moveF',
])
export default {
  props: {
    obj: {
      type: [Array, Object],
      default: () => {},
    },
    ncExportSetting: {
      type: [Array, Object],
      default: () => ({}),
    },
  },
  created() {
    this.getTagList()
  },
  computed: {
    ...mapGetters('equipEnvironment', ['showConfig']),
    ...mapState('equipEnvironment', ['showCode2']),
    knifeColumn() {
      const otherConfig = [
        {
          label: 'cuttingDock.drillSettings.toolTable.number',
          prop: 'number',
        },
        {
          label: 'cuttingDock.drillSettings.toolTable.number2',
          prop: 'number2',
        },
      ]
      if (!this.showConfig || !this.showCode2) {
        otherConfig.pop()
      }
      return otherConfig.concat(gangDrillTableConfig)
    },
    engravSwitchCloseAlwaysShow() {
      return this.$store.state.preferencesSetting.setting
        .engravSwitchCloseAlwaysShow
    },
  },
  data() {
    return {
      formData: {
        drills: [],
        enabled: true, // 记录是否启用排钻包
        prefix: '', // 排钻前缀
        suffix: '', // 排钻后缀
        beginCode: '', // 排钻启动代码
        endCode: '', // 排钻结束代码
        benchmarkDrill: '', // 基准钻
        drill_process_mode: 'recent_drill', // 排钻加工模式
        drill_benchmark: '', // 排钻组合下刀基准
      },
      rowIndex: -1,
      columnIndex: -1,
      currentRow: {},
      drillTableData: [],
      isDriliingChecked: true,
      gangDrillCombinationAuxiliaryList: [], //从孔列表
      drillRowName: '',
      drillColumnProperty: '',
      drillCode: '', //样例代码
      drillMode: [
        {
          label: this.$t('cuttingDock.drillSettings.processSetting.recentHole'),
          value: 'recent_hole',
          id: 'engraving_setting_drill_default_mode',
        },
        {
          label: this.$t('cuttingDock.drillSettings.processSetting.groupHole'),
          value: 'group_hole',
          id: 'engraving_setting_drill_tool_change_mode',
        },
      ],
      drillRow: null,
      drillColumn: null, // 当前列
      cellDom: null, // 当前单元格td dom树
      dragItem: null, // 拖拽的元素
      allTagList: null,
      drillInfo: {
        drillingNum: [], // 排钻编号
        drillingNumPrefix: [], // 前缀
        drillingNumSuffix: [], // 后缀
      }, // 排钻组合数据
    }
  },
  watch: {
    obj(val) {
      if (Object.keys(this.obj).length > 0) {
        this.isDriliingChecked = val.gangDrillCombinationEnable
        this.gangDrillCombinationAuxiliaryList =
          val.gangDrillCombinationAuxiliaryList
        this.formatDrillData(val)
        let s = JSON.parse(JSON.stringify(this.obj))
        const srcDrills = val.drills || []
        let benchmarkNumber = ''
        for (let i = 0; i < srcDrills.length; i++) {
          if (srcDrills[i]._selected) {
            const num = srcDrills[i].number
            benchmarkNumber = num !== '' && num != null ? String(num) : ''
            break
          }
        }
        s.drills.forEach((v) => {
          v._selected = false
          v.originNumber2 = v.number2
        })
        s.drills.forEach((v) => {
          if (benchmarkNumber !== '' && v.number == benchmarkNumber) {
            v._selected = true
          }
          if (v.isUsed == '') {
            v.isUsed = false
          }
        })
        s.benchmarkDrill = benchmarkNumber
        this.formData = s
      }
    },
    drillTableData: {
      deep: true,
      handler(val) {
        const drills = val.slice(0, val.length - 2)
        const more = val.slice(-2)
        let str =
          drills
            .map((drill, index) => drill.prefix + (10 + index) + drill.suffix)
            .join('') + more.map((e) => e.prefix).join('')
        this.drillCode = str
      },
    },
  },
  methods: {
    getIdKey(row) {
      return row.name.slice(2).length > 0 ? row.name.slice(2) : '0'
    },

    /**
     * @desc 判断当前输入框是否更改为文本域
     * @param field
     * @return {String} 'textarea' | 'text'
     */
    textareaJudge(field) {
      return textAreaFieldSet.has(field) ? 'textarea' : 'text'
    },
    translateLang(key) {
      return translate(key)
    },
    formatDrillData(data, isEdit = false) {
      // 工具函数：兼容字符串和对象
      const getTemplateString = (val) =>
        typeof val === 'string' ? val : val?.template_string || ''

      const getLabelIds = (val) =>
        typeof val === 'string' ? {} : val?.label_ids || {}

      // 主孔
      const zhukong = {
        name: '主孔',
        prefix: isEdit
          ? this.drillTableData[0]?.prefix || ''
          : getTemplateString(data.gangDrillCombinationMainPrefix),
        suffix: isEdit
          ? this.drillTableData[0]?.suffix || ''
          : getTemplateString(data.gangDrillCombinationMainSuffix),
        knifePrefix: {
          label_ids: getLabelIds(data.gangDrillCombinationMainPrefix),
          template_string: getTemplateString(
            data.gangDrillCombinationMainPrefix
          ),
        },
        knifeSuffix: {
          label_ids: getLabelIds(data.gangDrillCombinationMainSuffix),
          template_string: getTemplateString(
            data.gangDrillCombinationMainSuffix
          ),
        },
      }

      // 从孔
      const congKongList = this.gangDrillCombinationAuxiliaryList.map(
        (e, idx) => ({
          name: `从孔${idx + 1}`,
          prefix: getTemplateString(e.knifePrefix),
          suffix: getTemplateString(e.knifeSuffix),
          knifePrefix: {
            label_ids: getLabelIds(e.knifePrefix),
            template_string: getTemplateString(e.knifePrefix),
          },
          knifeSuffix: {
            label_ids: getLabelIds(e.knifeSuffix),
            template_string: getTemplateString(e.knifeSuffix),
          },
          webId: e.webId,
        })
      )

      // 组合注释
      const comment = {
        name: '组合注释',
        prefix: isEdit
          ? this.drillTableData[this.drillTableData.length - 2]?.prefix || ''
          : getTemplateString(data.gangDrillCombinationComment),
        knifePrefix: {
          label_ids: getLabelIds(data.gangDrillCombinationComment),
          template_string: getTemplateString(data.gangDrillCombinationComment),
        },
        suffix: '',
      }

      // 首次启用注释
      const firstSign = {
        name: '首次启用注释',
        prefix: isEdit
          ? this.drillTableData[this.drillTableData.length - 1]?.prefix || ''
          : getTemplateString(data.gangDrillCombinationuCommentFirstSign),
        knifePrefix: {
          label_ids: getLabelIds(data.gangDrillCombinationuCommentFirstSign),
          template_string: getTemplateString(
            data.gangDrillCombinationuCommentFirstSign
          ),
        },
        suffix: '',
      }
      this.drillTableData = [zhukong, ...congKongList, comment, firstSign]
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        rowIndex === this.drillTableData.length - 1 ||
        rowIndex === this.drillTableData.length - 2
      ) {
        if (columnIndex === 1) {
          return [1, 2]
        }
      }
    },
    // 自定义行样式
    comstumRow({ row, rowIndex }) {
      if (
        rowIndex === this.drillTableData.length - 1 ||
        rowIndex === this.drillTableData.length - 2
      ) {
        return {
          height: '90px',
        }
      }
    },
    // 组合排钻表格点击
    drillCellClick(row, column, cell, event) {
      this.drillRow = row
      this.drillColumn = column
      if (column.property === 'name') {
        return
      } else {
        this.drillRowName = row.name
        this.drillColumnProperty = column.property
      }
    },
    // 添加从孔
    handleAddHole() {
      this.gangDrillCombinationAuxiliaryList = this.drillTableData
        .filter((e) => e.name.includes('从孔'))
        .map((e) => ({
          knifePrefix: e.prefix,
          knifeSuffix: e.suffix,
          webId: e.webId,
        }))
      this.gangDrillCombinationAuxiliaryList.push({
        knifePrefix: '',
        knifeSuffix: '',
      })
      this.formatDrillData(this.obj, true)
    },
    handleDeleteHole() {
      this.gangDrillCombinationAuxiliaryList.pop({
        knifePrefix: '',
        knifeSuffix: '',
      })
      this.formatDrillData(this.obj, true)
    },
    changeBenchDrill(row, type) {
      if (row.number == '') {
        this.$message({
          message: this.$t('cuttingDock.drillSettings.changeBenchDrillTip'),
          offset: 60,
          type: 'info',
          duration: 1000,
        })
        return
      }
      if (row._selected == false) {
        this.formData.drills.forEach((v) => {
          v._selected = false
        })
        this.formData.benchmarkDrill = ''
      }
      if (row._selected == true) {
        this.formData.drills.forEach((v) => {
          v._selected = false
        })
        row._selected = true
        this.formData.benchmarkDrill = row.number
      }
    },
    addNewKnife() {
      this.formData.drills.push({
        diameter: '',
        feedRate: '',
        isUsed: true,
        moveF: '',
        moveZF: '',
        number: '',
        number2: '',
        originNumber2: '',
        origin: '',
        xOffset: '',
        yOffset: '',
        [webId]: genUniId(),
      })
    },
    deleteKnife() {
      const row = this.formData.drills[this.currentRow.index]
      // 删除基准行、或编号仍与 benchmarkDrill 一致时清空（改编号后仅 _selected 仍可靠）
      if (row._selected || row.number === this.formData.benchmarkDrill) {
        this.formData.benchmarkDrill = ''
      }

      this.formData.drills.splice(this.currentRow.index, 1)
    },
    //把每一行的索引加到行数据中
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    //把每一列的索引加到列数据中
    tableCellClassName({ column, columnIndex }) {
      column.index = columnIndex
    },
    cellClick(row, column, cell, event) {
      if (column.property == 'isUsed' || column.property == 'benchDrill') {
        return
      } else {
        this.rowIndex = row.index
        this.columnIndex = column.index
        this.currentRow = row
        if (column.property != 'type') {
          this.$nextTick(() => {
            this.$refs['editInput'][0].focus()
          })
        }
      }
    },
    handleTableInput(row, prop) {
      this.setKnifeLabel(row, prop)
    },
    inputBlur(row, prop) {
      this.rowIndex = -1
      this.columnIndex = -1
      this.drillRowName = ''
      this.drillColumnProperty = ''
      if (row && prop === 'number' && row._selected) {
        if (row.number === '') {
          row._selected = false
          this.formData.benchmarkDrill = ''
        } else {
          this.formData.benchmarkDrill = row.number
        }
      }
      if (row && prop == 'number2' && row.number2 != row.originNumber2) {
        buryPointApi('equipment_dock', 'gang_drill_number2')
      }
    },
    cancelBenchDrill(row, prop) {
      const numKeys = ['diameter', 'xOffset', 'yOffset']
      if (numKeys.includes(prop)) {
        row[prop] = verifyInputNumber(
          row[prop],
          this.formData.drills,
          [prop],
          '5-2',
          prop == 'diameter' ? false : true,
          '',
          true
        )
      }
      if (this.currentRow.number == '') {
        this.currentRow._selected = false
      }
    },
    // 拖拽标签
    handleStartDrag(event, item) {
      event.dataTransfer.setData('text/plain', `{${item.label_name_show}}`)
      this.dragItem = item
    },
    handleDrop(event, row, prop) {
      if (!this.checkLabelAllow(row, this.dragItem)) {
        // 当检查不通过直接阻止默认行为即可不添加标签
        event.preventDefault()
        return
      }
      this.drillRow = row
      // 然后使用 setTimeout 在默认行为完成后读取值
      setTimeout(async () => {
        const textarea = event.target
        row[prop] = textarea.value
        await this.$nextTick()
        // 将光标的结束位置赋值给起始位置，取消拖动之后的选中问题
        textarea.selectionStart = textarea.selectionEnd
        this.setKnifeLabel(row, prop, this.dragItem)
        // 埋点
      }, 10)
      this.buryPoint()
    },
    // 复制标签
    handleCopyTag(index, item) {
      if (!this.checkLabelAllow(this.drillRow, item)) return
      this.drillRow[this.drillColumn.property] += `{${item.label_name_show}}`
      this.setKnifeLabel(this.drillRow, this.drillColumn.property, item)
      // 埋点
      this.buryPoint()
    },
    // 校验标签是否允许插入主孔/从孔
    checkLabelAllow(row, item) {
      if (!row) return false
      const ignors = ['drillingNumPrefix', 'drillingNumSuffix']
      const hasCongKong = row.name.indexOf('从孔') !== -1
      const hasZhuKong = row.name.indexOf('主孔') !== -1
      if ((hasCongKong || hasZhuKong) && ignors.includes(item.label_type)) {
        return false
      }
      return true
    },
    checkLabelIds(row, prop, item) {
      //
    },
    // 统一设置 knifePrefix/knifeSuffix 的方法
    setKnifeLabel(row, prop, item) {
      // 通用方法：根据当前内容同步 label_ids，仅保留实际存在的标签
      const getLabelIdsFromStr = (str) => {
        const labelIds = {}
        if (this.allTagList && Array.isArray(this.allTagList)) {
          this.allTagList.forEach((tag) => {
            const tagStr = `{${tag.label_name_show}}`
            if ((str || '').includes(tagStr)) {
              labelIds[tag.label_name_show] = tag.id
            }
          })
        }
        return labelIds
      }
      if (prop === 'prefix') {
        row['knifePrefix'] = {
          label_ids: getLabelIdsFromStr(row.prefix),
          template_string: row.prefix,
          webId: genUniId(),
          name: row.name,
        }
      } else if (prop === 'suffix') {
        row['knifeSuffix'] = {
          label_ids: getLabelIdsFromStr(row.suffix),
          template_string: row.suffix,
          webId: genUniId(),
          name: row.name,
        }
      }
    },
    // 获取排钻组合池数据
    async getTagList() {
      const res = await getElectronicSawLabel('drillingInfo')
      this.drillInfo = res.data || {
        drillingNum: [],
        drillingNumPrefix: [],
        drillingNumSuffix: [],
      }
      const { drillingNum, drillingNumPrefix, drillingNumSuffix } =
        this.drillInfo
      this.allTagList = [
        ...drillingNum,
        ...drillingNumPrefix,
        ...drillingNumSuffix,
      ]
    },
    // 埋点
    buryPoint() {
      buryPointApi('engraving', 'select_tag')
    },
  },
}
</script>

<style scoped lang="less">
.gang-drill {
  // margin: 24px 24px 0 24px;
  .head-title {
    display: flex;
    align-items: center;
    background: #fff;
    span {
      margin-right: 1rem;
      font-weight: 400;
      font-size: 1.25rem;
    }
  }
  .gang-drill-table {
    box-sizing: border-box;
    // margin-top: 1.5rem;
    margin-top: 16px;
    padding: 1.5rem 1.5rem 1rem 1.5rem;
    background: #fff;
    .table-box {
      height: 33.0625rem;
      max-height: 33.0625rem;
    }
  }
  .code-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0.5rem 1.5rem 1.5rem 1.5rem;
    background: #fff;
    span {
      cursor: default;
    }
    textarea {
      display: block;
      width: 29.125rem;
      height: 7.0625rem;
      margin-top: 0.5rem;
      border: 0.0625rem solid #dddddd;
      border-radius: 0.25rem;
      resize: none;
    }
    & > div:nth-child(2n + 1) {
      margin-right: 8rem;
    }
    & > div:first-child {
      margin-bottom: 1.5rem;
    }
    & > div:nth-child(2) {
      margin-bottom: 1.5rem;
    }
    span {
      color: #000;
      font-weight: 400;
      font-size: 1rem;
    }
  }
  .drilling-part {
    background-color: #fff;
    .drilling-title {
      .el-checkbox {
        /deep/ .el-checkbox__inner {
          width: 20px;
          height: 20px;
        }
        /deep/ .el-checkbox__inner::after {
          height: 12px;
          width: 7px;
          top: 0;
          left: 5px;
        }
      }
    }
    .drilling-content {
      display: flex;
      .left-table {
        width: 541px;
        margin-right: 50px;
        margin: 20px 50px 20px 0;
        .drill-fix {
          margin-bottom: 0;
        }
      }
      .right-text {
        .drill-fix {
          margin-bottom: 0;
        }
      }
    }
  }
  .process-setting {
    padding: 24px;
  }
}
.tag-box {
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  .custom-form-head {
    box-sizing: border-box;
    height: 44px;
    padding: 11px 24px;
    background: #e9e9e9;
    span:first-child {
      color: #000;
      font-weight: 600;
      font-size: 16px;
    }
    span:last-child {
      color: #8c8c8c;
      font-size: 14px;
    }
  }
}

&:last-child .tag-item {
  border-bottom: none;
}
.tag-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  align-items: flex-start;
  padding: 19px 0 21px 0;
  border-bottom: 1px solid #e9e9e9;
  & > span {
    display: inline-block;
    width: 128px;
    font-size: 16px;
    text-align: right;
    user-select: none;
  }
  .tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    & > span {
      padding: 0 5px;
      display: inline-block;
      min-width: 102px;
      height: 32px;
      margin: 10px;
      color: #5a5a5a;
      font-size: 14px;
      line-height: 32px;
      text-align: center;
      background: #eaf4f6;
      cursor: pointer;
    }
  }
}
</style>
